import { LoginWrapper } from 'components/views/pages/login/LoginWrapper';
import { LoginModeEnum } from 'components/views/pages/login/types';

const LoginHost = () => {
  return <LoginWrapper mode={LoginModeEnum.host} />;
};

export default LoginHost;
